export const storeContractorFragments = {};
